import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { pickLabel, share } from './helpers';

/**
 * Одна кольцевая диаграмма разреза (Chart.js 2 / react-chartjs-2 v2). Легенда постоянно
 * видима (рисуется в JSX, не в canvas), проценты не прячутся в подсказку. Нажатие на
 * сектор ИЛИ на строку легенды = тот же фильтр, что и выпадающий список (один механизм).
 * Повтор снимает; активная строка подсвечена.
 *
 * @param {{id:string, title:string, items:Array<{key,label_ru,label_kk,n,color}>}} def
 */
export default function PieChartCard({ def, activeKey, onToggle }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const total = def.items.reduce((a, c) => a + c.n, 0);

  const data = {
    labels: def.items.map((c) => pickLabel(c, lng)),
    datasets: [
      {
        data: def.items.map((c) => c.n),
        backgroundColor: def.items.map((c) => c.color),
        borderColor: '#1e2532',
        borderWidth: 2,
      },
    ],
  };

  // Chart.js 2: legend/tooltips на верхнем уровне; tooltips во множественном числе.
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 52,
    legend: { display: false },
    tooltips: {
      callbacks: {
        label: (item, dt) => {
          const label = dt.labels[item.index];
          const value = dt.datasets[0].data[item.index];
          return `${label}: ${value} ${t('schools.pcs')} (${share(value, total)}%)`;
        },
      },
    },
  };

  // ключ по составу данных — в react-chartjs-2 v2 гарантирует перерисовку при смене выборки
  const sig = def.items.map((c) => `${c.key}:${c.n}`).join(',');

  return (
    <div className="sch-pie-card">
      <div className="sch-pie-title">{def.title}</div>
      <div className="sch-pie-box">
        {total > 0 ? (
          <Doughnut
            key={sig}
            data={data}
            options={options}
            onElementsClick={(elems) => {
              if (elems && elems.length) onToggle(def.id, def.items[elems[0]._index].key);
            }}
          />
        ) : null}
      </div>
      <div className="sch-pie-legend">
        {def.items.map((c) => (
          <div
            className={`row${activeKey === c.key ? ' on' : ''}`}
            key={c.key}
            onClick={() => onToggle(def.id, c.key)}
          >
            <i className="sw" style={{ background: c.color }} />
            <span className="nm">{pickLabel(c, lng)}</span>
            <span className="vl">
              {c.n} {t('schools.pcs')} · {share(c.n, total)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
